"use client";

import { IFilterOption } from "@faire/web-api/indigofair/data/IFilterOption";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { isNotNull } from "@faire/web/common/typescriptUtils";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Tab, Tabs } from "@faire/web/slate/Tabs";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled, { css } from "styled-components";

export const FilterTabsBase: React.FC<{
  onTabChange: (categoryFilterKey: string) => void;
  activeTab: string;
  onScroll?: (start: number, end: number) => void;
  categoryFilterOptions: Array<IFilterOption> | null;
}> = ({ onTabChange, activeTab, onScroll, categoryFilterOptions }) => {
  const ssr = useIsSSR();

  if (!categoryFilterOptions?.length) {
    return <Spacer width="5x" />;
  }

  return (
    <StyledTabs
      data-test-id="category-filters"
      $ssr={ssr}
      tabs={categoryFilterOptions
        .map((category): Tab<string> | null => {
          if (category.key && category.display_name) {
            return {
              value: category.key,
              label: category.display_name,
            };
          } else {
            return null;
          }
        })
        .filter(isNotNull)}
      activeTab={activeTab}
      onTabChange={onTabChange}
      onScroll={onScroll}
      tabAs="h2"
      autoScrollIntoView
    />
  );
};

const StyledTabs = styled(Tabs)<{ $ssr: boolean }>`
  margin-bottom: ${getSpacing("2x")};

  ${(props) =>
    props.$ssr
      ? css`
          button {
            opacity: 0.3;
            cursor: wait;
          }
        `
      : ""}

  ${responsiveMediaQueries.mobile} {
    margin: ${getSpacing("0", "-2x", "2x", "-2x")};
    width: unset;
    position: sticky;
    top: 0;
    z-index: 11;
    background: white;
  }
`;
